import React, { useState, useRef, useCallback } from "react";
import { useAuth } from "../../context/context";
import { useClickOutside } from "../../hooks/useClickOutside";

const Nav = () => {
  const [definitionsMenuOpen, setDefinitionsMenuOpen] = useState(false);
  const [adminMenuOpen, setAdminMenuOpen] = useState(false);

  // Create refs for the dropdown menus
  const adminMenuRef = useRef<HTMLLIElement>(null);
  const definitionsMenuRef = useRef<HTMLLIElement>(null);

  // Use the global auth context instead of local state
  const { isLoggedIn, logOutUser } = useAuth();

  // Handlers for closing the menus
  const closeAdminMenu = useCallback(() => {
    if (adminMenuOpen) setAdminMenuOpen(false);
  }, [adminMenuOpen]);

  const closeDefinitionsMenu = useCallback(() => {
    if (definitionsMenuOpen) setDefinitionsMenuOpen(false);
  }, [definitionsMenuOpen]);

  // Use our custom hook to handle outside clicks
  useClickOutside(adminMenuRef, closeAdminMenu);
  useClickOutside(definitionsMenuRef, closeDefinitionsMenu);

  const toggleDefinitionsMenu = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent event from bubbling up
    setDefinitionsMenuOpen(!definitionsMenuOpen);
    setAdminMenuOpen(false);
  };

  const toggleAdminMenu = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent event from bubbling up
    setAdminMenuOpen(!adminMenuOpen);
    setDefinitionsMenuOpen(false);
  };

  return (
    <div className="font-medium">
      <section>
        <nav className="flex bg-grayScale-700 text-white shadow-lg">
          <div className="flex justify-between px-5 py-3 w-full items-center">
            <div className="flex flex-row items-center">
              <img src="/wildXrLogo.png" alt="logo" width={50} />
              {isLoggedIn && (
                <ul className="hidden md:flex px-4 mx-6 font-heading space-x-12 text-lg">
                  <li>
                    <a className="hover:text-slate-300" href="/">
                      Videos
                    </a>
                  </li>
                  <li>
                    <a className="hover:text-slate-300" href="/videoCatalogues">
                      Video Catalogues
                    </a>
                  </li>
                  <li>
                    <a className="hover:text-slate-300" href="/mapMarkers">
                      Map Markers
                    </a>
                  </li>
                  <li>
                    <a className="hover:text-slate-300" href="/species">
                      Species{" "}
                    </a>
                  </li>

                  <li className="relative" ref={adminMenuRef}>
                    <button
                      onClick={toggleAdminMenu}
                      className="hover:text-slate-300"
                    >
                      Admin
                    </button>
                    {adminMenuOpen && (
                      <ul className="absolute z-50 mt-2 bg-grayScale-700 shadow-lg ">
                        <li>
                          <a
                            className="block px-4 py-2 hover:bg-grayScale-600"
                            href="/installations"
                          >
                            Installations{" "}
                          </a>
                        </li>
                        <li>
                          <a
                            className="block px-4 py-2 hover:bg-grayScale-600"
                            href="/devices"
                          >
                            Devices{" "}
                          </a>
                        </li>
                        <li>
                          <a
                            className="block px-4 py-2 hover:bg-grayScale-600"
                            href="/users"
                          >
                            Users
                          </a>
                        </li>

                        <li>
                          <a
                            className="block px-4 py-2 hover:bg-grayScale-600"
                            href="/organizations"
                          >
                            Organizations
                          </a>
                        </li>
                      </ul>
                    )}
                  </li>
                  <li className="relative" ref={definitionsMenuRef}>
                    <button
                      onClick={toggleDefinitionsMenu}
                      className="hover:text-slate-300"
                    >
                      Definitions
                    </button>
                    {definitionsMenuOpen && (
                      <ul className="absolute z-50 mt-2 bg-grayScale-700 shadow-lg ">
                        <li>
                          <a
                            className="block px-4 py-2 hover:bg-grayScale-600"
                            href="/countries"
                          >
                            Countries
                          </a>
                        </li>
                        <li>
                          <a
                            className="block px-4 py-2 hover:bg-grayScale-600"
                            href="/iucnStatus"
                          >
                            IUCN Status{" "}
                          </a>
                        </li>
                        <li>
                          <a
                            className="block px-4 py-2 hover:bg-grayScale-600"
                            href="/populationTrend"
                          >
                            Population Trend
                          </a>
                        </li>

                        <li>
                          <a
                            className="block px-4 py-2 hover:bg-grayScale-600"
                            href="/developmentNotice"
                          >
                            Tags{" "}
                          </a>
                        </li>
                      </ul>
                    )}
                  </li>
                </ul>
              )}
            </div>
            <div>
              {isLoggedIn && (
                <button
                  type="button"
                  onClick={logOutUser}
                  className="px-4 py-2 text-sm font-medium text-white bg-gray-500 rounded-full hover:bg-gray-600 transition"
                >
                  LOG OUT
                </button>
              )}
            </div>
          </div>
        </nav>
      </section>
    </div>
  );
};

export default Nav;
